'use client';

import { EmailVerification } from '@/components/email-verification';
import { GoBack } from '@/components/go-back';
import OptimizedLogo from '@/components/optimized-logo';
import { SignInForm } from '@/components/sign-in-form';
import { SocialAuth } from '@/components/social-auth';
import { buttonVariants } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { cn } from '@/lib/utils';
import Link from 'next/link';
import { useCallback, useState } from 'react';

export default function Signin() {
  const [isWaitingForVerification, setIsWaitingForVerification] =
    useState(false);
  const [userEmail, setUserEmail] = useState<string>('');

  const handleVerificationRequired = useCallback((email: string) => {
    setUserEmail(email);
    setIsWaitingForVerification(true);
  }, []);

  const handleBackFromVerification = useCallback(() => {
    setIsWaitingForVerification(false);
    setUserEmail('');
  }, []);

  return (
    <Card className="w-[400px] rounded-2xl relative">
      {!isWaitingForVerification && (
        <GoBack className="absolute top-5 left-4" />
      )}

      <CardHeader>
        <CardTitle className="flex items-center justify-center flex-col gap-6">
          <Link href="/">
            <OptimizedLogo color="black" width={200} height={32} />
          </Link>

          <h2 className="font-bold text-2xl">
            {isWaitingForVerification ? 'Verify account' : 'Log in'}
          </h2>
        </CardTitle>
      </CardHeader>

      {isWaitingForVerification ? (
        <EmailVerification
          userEmail={userEmail}
          onBack={handleBackFromVerification}
        />
      ) : (
        <CardContent className="space-y-4">
          <SignInForm onVerificationRequired={handleVerificationRequired} />
          <p className="text-center text-sm text-[#24292E]">OR</p>
          <SocialAuth isSignin />

          <p className="text-center text-sm text-[#24292E]">
            Don&apos;t have an account?
            <Link
              className={cn(buttonVariants({ variant: 'link' }), 'p-1')}
              href="sign-up"
            >
              Sign up
            </Link>
          </p>
        </CardContent>
      )}
    </Card>
  );
}
